import {BaseAnalyticsService} from 'app/services/analytics.services/analytics.service';
import {$Constants} from 'app/classes';

class GoogleAnalyticsService extends BaseAnalyticsService {
    public domain;
    public api;
    public appId;

    public init() {

        if (this.api) {
            return;
        }

        if (typeof $Constants.ga !== "undefined") {
            this.domain = $Constants.ga.domain;
            this.appId = $Constants.ga.appId;
        } else {
            console.warn('Missing google analytics constants. $Constants.ga');
            return;
        }

        // Google Analytics minfied junk. Broke this out into three separate functions
        // and added some Typescript types for compatibility
        // tslint is disabled for the Google code below

        /* tslint:disable */
        let gaSetup = function (i, s, o, g, r, a?, m?) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments)
                }, i[r].l = 1 * <any>new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        };
        /* tslint:enable */

        gaSetup(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
        (window as any).ga('create', this.appId, this.domain);
        this.api = (...args) => {
            (window as any).ga(...args);
        };
    }

    public sendEvent(event: string, metaData?: any) {
        this.api('send', 'event', event);
    }

}

export let googleAnalyticsService = new GoogleAnalyticsService();
